const publications = [
    {
        name: 'What Voting Rules Actually Do: A Data-Driven Analysis of Multi-Winner Voting',
        authors: 'Joshua Caiata, Ben Armstrong, Kate Larson',
        abstract: 'We introduce a data-driven framework for benchmarking decision rules using empirical performance rather than worst-case guarantees, and show that learned policies can outperform traditional rule-based systems in practice.\n\nThis paper was accepted to AAAI 2026.',
        link: 'https://arxiv.org/abs/2508.06454v1'
    },
    {
        name: 'Procedural Fairness in Multi-Agent Bandits',
        authors: 'Joshua Caiata, Carter Blair, Kate Larson',
        abstract: 'We analyze how influence is distributed in multi-agent systems, using bandits as a test case. We show that standard optimization policies centralize control and dilute agent influence. We introduce an equal-influence framework that preserves performance across objectives with minimal efficiency loss, reframing governance as a core system design choice.\n\nThis paper was accepted to the International Conference for Autonomous Agents and Multi-Agent Systems (AAMAS) 2026 as an extended abstract.',
        link: 'pf_bandits.pdf'
    }
];

export default publications;
